{
  "currentGroup": {
    "id": {}
  },
  "currentRole": {
    "id": {},
    "toolbar": {
      "addPermissions": {},
      "assignUser": {},
      "dropdown": {
        "assignGroup": {},
        "deleteRole": {}
      }
    },
    "tabs": {
      "detail": {},
      "users": {},
      "groups": {}
    },
    "detail": {
      "permissionList": {
        "permission": {
          "actions": {
            "remove": {}
          },
          "label": {}
        }
      }
    }
  },
  "currentUser": {
    "id": {}
  },
  "lists": {
    "group": {
      "id": {},
      "rolesCount": {}
    },
    "role": {
      "groupsCount": {},
      "id": {},
      "permissionsCount": {},
      "usersCount": {}
    },
    "user": {
      "id": {},
      "rolesCount": {}
    }
  }
}
